module.exports = __webpack_public_path__ + "static/media/Vileplume_gaussian2.a86fb9c1.png";